
import { cn } from "@/lib/utils"

interface BackgroundGradientProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: "default" | "subtle" | "accent";
}

export function BackgroundGradient({
  children,
  className,
  variant = "default",
  ...props
}: BackgroundGradientProps) {
  return (
    <div
      className={cn(
        "relative overflow-hidden bg-background",
        variant === "default" && "bg-gradient-to-br from-secondary/40 via-background to-background",
        variant === "subtle" && "bg-gradient-to-br from-secondary/10 via-background to-background",
        variant === "accent" && "bg-gradient-to-br from-primary/5 via-secondary/10 to-background",
        className
      )}
      {...props}
    >
      {variant !== "subtle" && (
        <div 
          className="absolute inset-0 opacity-25"
          aria-hidden="true"
        >
          <div className="absolute inset-0 bg-grid-white/10" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
        </div>
      )}
      <div className="relative z-10">{children}</div>
    </div>
  );
}
